import { AfterViewChecked, ChangeDetectorRef, Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ElasticExpedientesByKeyword, IResultadoDocument, ExpedienteFiltroDTO } from '../../core/model/inventories';
import { Page } from '../../core/model/page';
import { AuthenticationService } from '../../core/services/authentication.service';
import { FileDownloaderService } from '../../core/services/file-downloader.service';
import { InventariosService } from '../../core/services/inventarios.service';
import { UsersService } from '../../core/services/users.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-inventarios',
  templateUrl: './inventarios.component.html',
  styleUrls: ['./inventarios.component.css'],
  providers: [FileDownloaderService]
})
export class InventariosComponent implements OnInit, AfterViewChecked, OnDestroy {

  rootParent: string;
  rootChild: string;
  title: string;
  description: string;

  keyword: ElasticExpedientesByKeyword;
  advancedSearchFilter: ExpedienteFiltroDTO;

  isDocoutUser: boolean;
  hasTable = false;

  rechargeRecords = false;

  loading = false;
  page = new Page();
  datas: IResultadoDocument<any>[];
  nivelInventarioSerie: number;

  inventoryType: string;
  canExportInventories: boolean;

  permisoExtraerSeriesAlmacen: boolean;

  constructor(private translateService: TranslateService,
    private activatedRoute: ActivatedRoute,
    private authService: AuthenticationService,
    private cdRef: ChangeDetectorRef,
    private router: Router,
    private inventoryService: InventariosService,
    private userService: UsersService,
    private toastr: ToastrService
  ) {

    this.page.pageNumber = 0;
    this.page.size = 10;

    this.authService.getClienteName$().subscribe(beadcrumbDad => {
      this.rootParent = beadcrumbDad;
    });

    this.title = this.translateService.instant('inventory.inventories');
    this.description = this.translateService.instant('inventory.description');
    this.rootChild = this.translateService.instant('inventory.inventories');
  }

  isCalledFromConsultas(): boolean {
    return this.inventoryService.isCalledFromConsultas();
  }

  returnToSolicitud() {
    this.inventoryService.returnToSolicitud();
  }

  ngOnDestroy() {
    if (this.inventoryService.isCalledFromConsultas() && !this.inventoryService.notUnload) {
      this.inventoryService.restartConsultas();
    }
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  ngOnInit() {
    this.canExportInventories = this.authService.canExportInventories();

    this.activatedRoute.paramMap.subscribe((params: ParamMap) => {
      this.inventoryType = params.get('inventoryType');
      if (!this.inventoryType) {
        this.inventoryType = this.getInventoryType();
      }
    });

    this.inventoryService.notUnload = false;

    this.setPermisoExtraerSeries();
  }

  private getInventoryType(): string {
    const urlSplitPoints = this.router.url.split(':');
    const inventoryType = urlSplitPoints[urlSplitPoints.length - 1];
    return inventoryType.split('/')[0].replace(')', '');
  }

  changeRowsTable() {
    this.page.pageNumber = 0;
    if (this.hasTable) {
      this.rechargeRecords = true;
    }
  }

  setAdvancedSearchFilter(filter) {
    this.advancedSearchFilter = filter;
  }

  setPermisoExtraerSeries() {
    this.userService.getMostrarExtraerSeriesAlmacen()
      .subscribe(
        (resultadoBusqueda) => {
          this.permisoExtraerSeriesAlmacen = resultadoBusqueda;
        },
        (e: Error) => {
          this.toastr.error('No se ha podido recuperar el parametro PERMISOS EXTRAER SERIE del usuario');
        }
      );
  }
}
